<h1 mat-dialog-title>Message detail: {{ data['id'] }}</h1>
<mat-dialog-content>
  <pre>{{ data | json }}</pre>
  <h3>Parsed queueMessage:</h3>
  <pre>{{ JSON.parse(data.queueMessage) | json }}</pre>
</mat-dialog-content>
